import { differenceInCalendarDays, isBefore } from 'date-fns';
import type { PodaniPodaniInstanceDto } from '@gov-nx/api';
import { isKorespondencniHlasovaniSubmission } from '@gov-nx/api';
import type { Nullable } from '@gov-nx/core/types';
import { toDateReadable, today } from '@gov-nx/utils/common';

export interface SubmissionStatus {
	message?: 'vyrizeno' | 'lhuta-do' | 'v-prodleni' | 'odeslano';
	date: Nullable<string | number>;
}

export function prepareStatus(
	submission: PodaniPodaniInstanceDto
): SubmissionStatus {
	const date = today();

	if (isKorespondencniHlasovaniSubmission(submission)) {
		return {
			message: 'odeslano',
			date: submission.datumOdeslani
				? toDateReadable(submission.datumOdeslani)
				: null,
		};
	}

	if (submission.datumVyrizeni) {
		return {
			message: 'vyrizeno',
			date: toDateReadable(submission.datumVyrizeni),
		};
	}

	if (submission.automatickeZpracovani) {
		return { message: 'vyrizeno', date: null };
	}

	if (
		submission.lhutaVyrizeni &&
		isBefore(date, today(submission.lhutaVyrizeni))
	) {
		return {
			message: 'lhuta-do',
			date: toDateReadable(submission.lhutaVyrizeni),
		};
	}

	const diff = differenceInCalendarDays(date, today(submission.lhutaVyrizeni));
	if (submission.lhutaVyrizeni && diff > 0) {
		return {
			message: 'v-prodleni',
			date: diff,
		};
	}

	return { message: undefined, date: null };
}
